<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
            <el-form-item label="过期天数：">
                <input class="input-defind" v-model="searchForm.remainExpireDate" 
                @keyup="formatDate()" 
                @blur="formatDate()" 
                placeholder="请输入过期天数"
                clearable>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getAgentExpireSimListHandle">搜索查询</el-button>
                <el-button type="success"  @click="exportAgentEndTimeSimHandle">导出Excel</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column label="ICCID号" width="180px">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号码" width="130px"></el-table-column>
            <el-table-column prop="remainsDay" label="剩余天数 "></el-table-column>
            <el-table-column prop="agentName" label="所属代理商"></el-table-column>
            <el-table-column prop="activationrTime" label="激活时间"></el-table-column>
            <el-table-column prop="expireTime" label="到期时间"></el-table-column>
            <el-table-column prop="totalFlow" label="总流量(M)"></el-table-column>
            <el-table-column prop="useFlow" label="已使用流量(M)"></el-table-column>
            <el-table-column prop="remainsFlow" label="剩余流量(M)"></el-table-column>
            <el-table-column prop="stateName" label="卡状态"  width="100px"></el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                   <el-button type="text" size="small" @click="showBackMoneyDialog(scope.row)">续费SIM卡</el-button>
                </template>    
            </el-table-column>
        </el-table>  
         <el-dialog :append-to-body="true"  title="续费SIM卡" :visible.sync="backMoneyDialogVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{rowData.iccid}}</span>
            </div>
            <div class="lineInDialog">
                <label>单卡金额：</label>
                <span>{{rowData.simPrice}} 元</span>
            </div>
            <div class="lineInDialog">
                <label>续费月份：</label>
                <span>{{rowData.simLife}} 月</span>
            </div>
            <!-- 1 包月 2包年 -->
             <div v-if="rowData.type==1" class="lineInDialog">
                <label>总金额：</label>
                <span>{{rowData.simLife * rowData.simPrice }} 元</span>
            </div>
            <div v-else class="lineInDialog">
                <label>总金额：</label>
                <span>{{rowData.simPrice }} 元</span>
            </div>
            <div class="lineInDialog">
                <label>续费备注：</label>
                <el-input  type="textarea" placeholder="请输入内容" :rows="5" v-model.trim="backMoneyForm.remark" clearable></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelToBackMoney">取 消</el-button>
                <el-button type="primary" @click="handleBackMoney">申 请</el-button>
            </span>            
        </el-dialog>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>        
    </div>
</template>

<script>
import {getAgentExpireSimList, exportSimInfo} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {

            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            backMoneyDialogVisible:false,
             rowData:{},
              backMoneyForm:{
                remark:"",
                id:''
            },
              formDate:{},

            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            }            
        }
    },
    methods: {
        handleBackMoney(){
            if(this.backMoneyForm.remark == ''){
                this.$message.error('请先输入续费备注！');
                return;
            }
            this.backMoneyForm.id=this.rowData.id;
        

            this.$confirm('确定要提交续费吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                 common.sysRequest('agent/expire/time/add', this.backMoneyForm, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success("续费成功");
                }else{
                    this.$message.error(res.data.message);
                }
                this.cancelToBackMoney();
                this.backMoneyForm.remark = '';
                this.getAgentExpireSimListHandle();
               })
            }).catch(() => {

            });
            
        },
        cancelToBackMoney(){
            this.backMoneyDialogVisible = false;
            this.formDate.delete('payImg');
            this.formDate.delete('orderId');
            this.formDate.delete('rqReason');
            this.rowData.id = '';
            this.backMoneyForm.remark = '';
        },
        //“退款操作” 对话框
        showBackMoneyDialog(row){
             common.sysRequest('/agent/have/power', {}, 'post').then(res => {
                if(res.data.code == 200){
                     this.backMoneyDialogVisible = true;
                      this.rowData = row;
                }else{
                    this.$message.error(res.data.message);
                }
            })   
          
        },
        cancel(){
            this.simHandleVisibale = false;    
            this.$refs.simHandleForm.resetFields();  
        },
        getAgentExpireSimListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getAgentExpireSimList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        formatDate(){
            this.searchForm.remainExpireDate = this.searchForm.remainExpireDate.replace(/\D/g,'');
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'endTimeList');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('detailMenu').click();
        },
        exportAgentEndTimeSimHandle(){//导出excel文件
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
            common.sysRequest('/excels/agent/expire/sim/all', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('下载中，请稍后在下载中心查询');
                }else{
                    this.$message.error(res.data.message);
                }
            })            
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentExpireSimListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentExpireSimListHandle();
        }       
    },
    created () {
        this.getAgentExpireSimListHandle();
    }
}
</script>

<style lang="scss" scoped>
    .input-defind{
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;
    }
</style>

